import { useEffect } from "react";
import SEO from "@/components/SEO";
import { PABAU_BOOKING_URL } from "@/lib/constants";
import { absoluteUrl } from "@/lib/seo-config";
import { track } from "@/lib/analytics";

const bookBreadcrumb = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: absoluteUrl("/") },
    { "@type": "ListItem", position: 2, name: "Book", item: absoluteUrl("/book") },
  ],
};

export default function Book() {
  useEffect(() => {
    track("book_page_view", { source: "internal" });
  }, []);

  return (
    <>
      <SEO
        title="Book Your Session"
        description="Book a Clinical Massage Therapy session at Ashlan Clinic, Hamilton, Bermuda. Choose your Therapist, treatment and time — confirmed instantly."
        path="/book"
        schemas={[bookBreadcrumb]}
      />
      <main
        data-testid="book-page"
        className="bg-white text-[#080808] pt-[104px] pb-24"
      >
        <section className="max-w-[1180px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <p
              data-testid="book-eyebrow"
              className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#3A7A8C]"
            >
              Booking
            </p>
            <h1
              data-testid="book-heading"
              className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]"
            >
              Book Your Session
            </h1>
            <p
              data-testid="book-subheading"
              className="mt-5 text-lg text-[#3C4048] max-w-2xl leading-relaxed"
            >
              Choose your Therapist, treatment, and time — confirmed instantly.
            </p>
          </div>

          <div
            data-testid="book-widget-frame"
            className="mt-10 md:mt-14 border border-[#E5E7EB] bg-[#FAFAFA] p-2 md:p-3 rounded-none"
          >
            <iframe
              data-testid="book-widget-iframe"
              src={PABAU_BOOKING_URL}
              title="Ashlan Clinic Booking"
              loading="lazy"
              allow="payment; clipboard-write"
              referrerPolicy="strict-origin-when-cross-origin"
              className="w-full block bg-white"
              style={{ minHeight: "1100px", border: "none" }}
              onLoad={() => track("book_widget_loaded", {})}
            />
          </div>

          <div
            data-testid="book-fallback"
            className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm text-[#3C4048]"
          >
            <p>
              Having trouble booking?{" "}
              <a
                data-testid="book-fallback-link"
                href={PABAU_BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => track("book_fallback_click", {})}
                className="text-[#3A7A8C] font-semibold underline underline-offset-4 hover:text-[#080808]"
              >
                Open the booking page directly
              </a>
              .
            </p>
            <p className="text-[11px] uppercase tracking-[0.18em] text-[#6B7280]">
              Secure booking · Powered by Pabau
            </p>
          </div>
        </section>
      </main>
    </>
  );
}
